export default "__VITE_ASSET__COtFplxA__"